/** @format */

import { catchError, concatMap, map, take, timeout } from 'rxjs/operators';

import { AthleteManagementDao } from '@my-account/data-access/dao';
import { Injectable } from '@angular/core';
import { PersonalInformation } from '@shared/data-access/interfaces';
import { throwError } from 'rxjs';
import { Store } from '@shared/data-access/services';

@Injectable({
	providedIn: 'root'
})
export class AthleteManagementIdentityService {
	constructor(
		private dao: AthleteManagementDao,
		private store: Store
	) {}

	public getIdentity(timeoutEnabled = false) {
		return this.dao.getIdentity().pipe(
			// if timeoutEnabled is true, then the request will timeout after 5 seconds, if not, do nothing.
			timeoutEnabled ? timeout(5000) : map((result) => result),
			catchError((err) => {
				// If there's a timeout error, propogate it up
				return throwError(() => err);
			})
		);
	}

	public updateIdentity(firstName: string, lastName: string) {
		return this.dao.updateIdentity(firstName, lastName).pipe(
			concatMap((res) => {
				return this.store.selectDistinctKey<PersonalInformation>('PERSONAL_INFO').pipe(
					take(1),
					map((personalInfo) => {
						personalInfo.firstName = res.firstName;
						personalInfo.lastName = res.lastName;
						this.store.set('PERSONAL_INFO', personalInfo);
						return res;
					})
				);
			})
		);
	}
}
